// removed by extract-text-webpack-plugin
module.exports = {"ScrollDownButton":"ScrollDownButton-module__ScrollDownButton__1Jebo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexMain/ScrollDownButton/ScrollDownButton.module.css
// module id = 1714
// module chunks = 29